import "./OptimizationStrategy.module.css";
import Header from "@/reusable_sections/Header";
import DigitalGrowthSolutions from "./sections/DigitalGrowthSolutions";
import ServiceProcess from "./sections/ServiceProcess";
import SupportInquiry from "./sections/SupportInquiry";
import Footer from "@/reusable_sections/Footer";
export default function OptimizationStrategyPage() {
  return <div>
      <Header />
      <DigitalGrowthSolutions />
      <ServiceProcess />
      <SupportInquiry />
      <Footer />
    </div>;
}